/**
 * Step 1: Willkommen + Erklärung der nächsten 5 Schritte. Kein Input.
 * Cash-Konto und BTC werden in Step 2 / Step 5 erfasst — daher hier
 * bewusst keine Felder, um den Wizard schlank zu halten.
 */
export function Step1Welcome() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="tracked-caps text-sm text-ink">Willkommen bei Sextant</h2>
        <p className="mt-3 max-w-2xl font-mono text-sm leading-6 text-muted">
          Bevor das tägliche Monitoring losgeht, brauchst du einmalig ein paar Minuten für das
          Initial-Setup. Die App spiegelt anschließend deinen tatsächlichen Portfolio-Stand.
        </p>
      </div>

      <section className="hairline-y py-5">
        <p className="tracked-caps mb-3 text-[10px] text-faint">
          Was kommt in den nächsten Schritten
        </p>
        <ol className="flex flex-col gap-2 font-mono text-sm">
          <li className="flex items-baseline gap-3">
            <span className="w-6 text-right text-bernstein">2.</span>
            <span className="text-ink">
              Accounts anlegen — pro Broker (IBKR, Consors, Scalable, manuell oder external).
            </span>
          </li>
          <li className="flex items-baseline gap-3">
            <span className="w-6 text-right text-bernstein">3.</span>
            <span className="text-ink">
              Bestehende Positionen erfassen — manuell. CSV-Import folgt mit Phase 1b.
            </span>
          </li>
          <li className="flex items-baseline gap-3">
            <span className="w-6 text-right text-bernstein">4.</span>
            <span className="text-muted">
              Sparpläne — Phase-1b-Skelett, vollständige Erfassung mit dem CSV-Import.
            </span>
          </li>
          <li className="flex items-baseline gap-3">
            <span className="w-6 text-right text-bernstein">5.</span>
            <span className="text-ink">
              External Assets — BTC via CoinTracking, manuell gepflegt.
            </span>
          </li>
          <li className="flex items-baseline gap-3">
            <span className="w-6 text-right text-bernstein">6.</span>
            <span className="text-ink">
              Strategie bestätigen — Default-Allokation aus SEXTANT.md, später anpassbar via Fork.
            </span>
          </li>
        </ol>
      </section>

      <section>
        <p className="tracked-caps mb-3 text-[10px] text-faint">Vorbereitung</p>
        <p className="max-w-2xl font-mono text-sm leading-6 text-muted">
          Ideal mit den Daten aus <code className="text-ink">docs/user/02_ONBOARDING.md</code>{' '}
          griffbereit (Account-Übersichten, BTC-Wert aus CoinTracking). Wenn etwas fehlt, kannst du
          Schritte überspringen und später in der App nachholen.
        </p>
      </section>
    </div>
  )
}
